
export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  vessel: {
    carousel: {
      position: 'relative'
    },
    overlay: {
      position: 'absolute',
      width: 'full',
      pinTop: true,
      padding: 'sm',
      pointerEvents: 'none'
    },
    icon: {
      pointerEvents: 'auto',
      color: 'blue',
      padding: 'xs',
      fontSize: '2xl',
      backgroundColor: 'white',
      borderRadius: 'full',
      cursor: 'pointer',
      shadow: true
    }
  },
  computed: {
    hasImages() {
      return this.product.images.length
    },
    attachments() {
      if (!this.hasImages) return []

      const images = this.product.images
      const items = []

      images.forEach((item) => {
        items.push({
          src: item.src,
          title: this.product.name,
          $attrs: {
            ...item
          }
        })
      })

      return items
    }
  },
  methods: {
    onClick(slide, clickAllowed) {
      if (clickAllowed()) {
        this.$lightbox.show('gallery-carousel', slide)
      }
    }
  }
}
